import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as profitLossService from '../services/profitLossService'
import * as userService from '../services/userService'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import Autocomplete from 'react-autocomplete';
import Currency from './sub_components/currency'
import Toast from './sub_components/toast';
import { casinoList } from '../configs/casinoShowList';
import { CSVLink } from 'react-csv';
import { BASE_IMAGE_PATH_NEW } from '../configs/api';
import printJS from 'print-js'

class ProfitLoss extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         pnl_datanew:{},
         totalpnl: 0, 
         totalcommission: 0,
         totalnew: 0,
         from: "",
         to: "",
         accounts: "",
         client_id: "",
         usersList: [],
         toastMsg: "",
         toastType: "",
         showToast: false,
         showData: false,
         loader: false,
         isPnlData: false,
         eventNameById: {"1": "Soccer", "2": "Tennis", "4": "Cricket", "400": "Kabaddi", "500": "Election", "7": "Horse Racing", "4339": "Greyhound Racing"},
         csv_json: [],
         pdf_json: [],
      };
   }
   componentDidMount() {
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if(!(!!userData && !!userData.sub)){
         localStorage.clear();
         this.props.history.push("/auth")
      }
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ accounts: userData.sub, to: curDate, from: weekDate })
   }
   parseToPickerDate(date) {
      let dtArr = date.split("/")
      let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
      return dt
   }
   parseFilterBody() {
      // let body = { 
      //    "user_id": this.state.accounts,
      //    "client_id": this.state.client_id,
      //    "from": new Date(this.state.from).toISOString(),
      //    "to": new Date(this.state.to).toISOString(),
      // }
      let body = {
         "userId": this.state.client_id,
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
     }
      body = this.clean(body);
      return body
   }
   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      this.setState({ loader: true, totalnew: 0 })
      await profitLossService.postProfitLoss(body).then((res) => {
         let pnl_newdata={
            "MATCH_ODDS_4":{et:"4", sport:"Cricket", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "BOOKMAKER_4":{et:"4", sport:"Cricket", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "SPECIAL_MAKER_4":{et:"4", sport:"Cricket", mt:"SPECIAL_MAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "TIED_MATCH_4":{et:"4", sport:"Cricket", mt:"TIED_MATCH", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "COMPLETED_MATCH_4":{et:"4", sport:"Cricket", mt:"COMPLETED_MATCH", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "MINI_BOOKMAKER_4":{et:"4", sport:"Cricket", mt:"MINI_BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "TOURNAMENT_WINNER_4":{et:"4", sport:"Cricket", mt:"TOURNAMENT_WINNER", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "FANCY_4":{et:"4", sport:"Cricket", mt:"FANCY", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "LINE_4":{et:"4", sport:"Cricket", mt:"LINE", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "WINNING_ODDS_4":{et:"4", sport:"Cricket", mt:"WINNING_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "MATCH_ODDS_1":{et:"1", sport:"Soccer", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "BOOKMAKER_1":{et:"1", sport:"Soccer", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "SPECIAL_MAKER_1":{et:"1", sport:"Soccer", mt:"SPECIAL_MAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_85_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_85", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_75_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_75", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_65_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_65", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_55_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_55", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_45_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_45", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_35_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_35", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_25_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_25", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_15_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_15", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "OVER_UNDER_05_1":{et:"1", sport:"Soccer", mt:"OVER_UNDER_05", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "MINI_BOOKMAKER_1":{et:"1", sport:"Soccer", mt:"MINI_BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "WINNING_ODDS_1":{et:"1", sport:"Soccer", mt:"WINNING_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "MATCH_ODDS_2":{et:"2", sport:"Tennis", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "BOOKMAKER_2":{et:"2", sport:"Tennis", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "SPECIAL_MAKER_2":{et:"2", sport:"Tennis", mt:"SPECIAL_MAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "MINI_BOOKMAKER_2":{et:"2", sport:"Tennis", mt:"MINI_BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "WINNING_ODDS_2":{et:"2", sport:"Tennis", mt:"WINNING_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "WIN_7":{et:"7", sport:"Horse Racing", mt:"WIN", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "WIN_4339":{et:"4339", sport:"Greyhound Racing", mt:"WIN", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "BOOKMAKER_400":{et:"400", sport:"Kabaddi", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "SPECIAL_MAKER_400":{et:"400", sport:"Kabaddi", mt:"SPECIAL_MAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "FANCY_400":{et:"400", sport:"Kabaddi", mt:"FANCY", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "WINNING_ODDS_400":{et:"400", sport:"Kabaddi", mt:"WINNING_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "BOOKMAKER_500":{et:"500", sport:"Election", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "SPECIAL_MAKER_500":{et:"500", sport:"Election", mt:"SPECIAL_MAKER", bt:"BOOKMAKER", pnl: 0, commission: 0, pnl_commission: 0},
            "FANCY_500":{et:"500", sport:"Election", mt:"FANCY", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "WINNING_ODDS_500":{et:"500", sport:"Election", mt:"WINNING_ODDS", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
            "DAILY_300":{et:"300", sport:"Binary", mt:"DAILY", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "1_HOUR_300":{et:"300", sport:"Binary", mt:"1_HOUR", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0},
            "2_HOUR_300":{et:"300", sport:"Binary", mt:"2_HOUR", bt:"LINE", pnl: 0, commission: 0, pnl_commission: 0}
         }
         //    "INDIAN_POKER_99":{et:"99", sport:"Casino", mt:"INDIAN_POKER", bt:"LOTUS", pnl_commission: 0},
         //    "INDIAN_POKER_2_99":{et:"99", sport:"Casino", mt:"INDIAN_POKER_2", bt:"SUPERNOVA", pnl_commission: 0},
         //    "CASINO_99":{et:"99", sport:"Casino", mt:"CASINO", bt:"DRC || QTECH", pnl_commission: 0},
         //    "EVOLUTION_99":{et:"99", sport:"Casino", mt:"EVOLUTION", bt:"ODDS", pnl_commission: 0},
         //    "DIGITAIN_999":{et:"999", sport:"SportBook", mt:"SPORTBOOK", bt:"ODDS", pnl_commission: 0}
         // }

         for(const itm of casinoList){
            // if(itm.show){
               pnl_newdata[itm.pnlLabel] = {et:"99", sport:"Casino", mt:itm.mt, bt:itm.bt, pnl: 0, commission: 0, pnl_commission: 0};
            // }
         }

         pnl_newdata["DIGITAIN_999"] = {et:"999", sport:"SportBook", mt:"SPORTBOOK", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0};

         if (res.isSuccess) {
            self.setState(
               {
                  pnl_datanew:{},
                  totalnew:0,
                  isPnlData: false,

               }, () => {
                  
                  let totalpnl = 0
                  let totalcommission = 0
                  let totalnew = 0
                  res.items.length > 0 && Array.prototype.forEach.call(res.items,(it) => {
                     if ((it._id.bt === "ODDS" || it._id.bt === "BOOKMAKER") && it._id.et !== "99" && it._id.et !== "999") {
                        if(!!pnl_newdata[`${it._id.mt}_${it._id.et}`]){
                           pnl_newdata[`${it._id.mt}_${it._id.et}`].pnl += it.pnl
                           pnl_newdata[`${it._id.mt}_${it._id.et}`].commission += it.commission 
                           pnl_newdata[`${it._id.mt}_${it._id.et}`].pnl_commission += it.pnl + it.commission
                           totalpnl += it.pnl
                           totalcommission += it.commission
                           totalnew += it.pnl + it.commission
                        }
                     }
                     else if (it._id.bt === "LINE" && it._id.provider !== "BETFAIR" && it._id.et === "4") {
                        if(!!pnl_newdata[`FANCY_${it._id.et}`]){
                           pnl_newdata[`FANCY_${it._id.et}`].pnl += it.pnl
                           pnl_newdata[`FANCY_${it._id.et}`].commission += it.commission
                           pnl_newdata[`FANCY_${it._id.et}`].pnl_commission += it.pnl + it.commission
                           totalpnl += it.pnl
                           totalcommission += it.commission
                           totalnew += it.pnl + it.commission
                        }
                     }
                     else if (it._id.bt === "LINE" && it._id.provider === "BETFAIR" && it._id.et === "4") {
                        if(!!pnl_newdata[`LINE_${it._id.et}`]){
                           pnl_newdata[`LINE_${it._id.et}`].pnl += it.pnl
                           pnl_newdata[`LINE_${it._id.et}`].commission += it.commission
                           pnl_newdata[`LINE_${it._id.et}`].pnl_commission += it.pnl + it.commission
                           totalpnl += it.pnl
                           totalcommission += it.commission
                           totalnew += it.pnl + it.commission
                        }
                     }
                     else if (it._id.bt === "LINE" && (it._id.et === "500" || it._id.et === "400")) {
                        if(!!pnl_newdata[`FANCY_${it._id.et}`]){
                           pnl_newdata[`FANCY_${it._id.et}`].pnl += it.pnl
                           pnl_newdata[`FANCY_${it._id.et}`].commission += it.commission
                           pnl_newdata[`FANCY_${it._id.et}`].pnl_commission += it.pnl + it.commission
                           totalpnl += it.pnl
                           totalcommission += it.commission
                           totalnew += it.pnl + it.commission
                        }
                     }
                     else if (it._id.mt === "DAILY" && it._id.et === "300") {
                        if(!!pnl_newdata[`DAILY_${it._id.et}`]){
                           pnl_newdata[`DAILY_${it._id.et}`].pnl += it.pnl
                           pnl_newdata[`DAILY_${it._id.et}`].commission += it.commission
                           pnl_newdata[`DAILY_${it._id.et}`].pnl_commission += it.pnl + it.commission
                           totalpnl += it.pnl
                           totalcommission += it.commission
                           totalnew += it.pnl + it.commission
                        }
                     }
                     else if (it._id.mt === "1_HOUR" && it._id.et === "300") {
                        if(!!pnl_newdata[`1_HOUR_${it._id.et}`]){
                           pnl_newdata[`1_HOUR_${it._id.et}`].pnl += it.pnl
                           pnl_newdata[`1_HOUR_${it._id.et}`].commission += it.commission
                           pnl_newdata[`1_HOUR_${it._id.et}`].pnl_commission += it.pnl + it.commission
                           totalpnl += it.pnl
                           totalcommission += it.commission
                           totalnew += it.pnl + it.commission
                        }
                     }
                     else if (it._id.mt === "2_HOUR" && it._id.et === "300") {
                        if(!!pnl_newdata[`2_HOUR_${it._id.et}`]){
                           pnl_newdata[`2_HOUR_${it._id.et}`].pnl += it.pnl
                           pnl_newdata[`2_HOUR_${it._id.et}`].commission += it.commission
                           pnl_newdata[`2_HOUR_${it._id.et}`].pnl_commission += it.pnl + it.commission
                           totalpnl += it.pnl
                           totalcommission += it.commission
                           totalnew += it.pnl + it.commission
                        }
                     } else if(it._id.et === "99"){
                        //let obj = pnl_newdata[`${it._id.provider}_${it._id.et}`];
                        const objkey = `${(it._id.provider === "LOTUS" ? "INDIAN_POKER_II" : (it._id.provider === "SUPERNOVA" ? "INDIAN_POKER_II" : (it._id.provider === "DRC" || it._id.provider === "QTECH" ? "CASINO" :(it._id.provider === "DRCROYAL"? "INDIAN_POKER/LIVE_CASINO" :(it._id.provider === "DRCHUD"? "CASINO_III" : it._id.provider)))))}_${it._id.et}`
                        if(!!pnl_newdata[objkey]){
                           pnl_newdata[objkey].pnl += it.pnl
                           pnl_newdata[objkey].commission += it.commission
                           pnl_newdata[objkey].pnl_commission += it.pnl + it.commission;
                           totalpnl += it.pnl
                           totalcommission += it.commission
                           totalnew += it.pnl + it.commission;
                        }
                     }
                     else if (it._id.provider === "DIGITAIN") {
                        pnl_newdata[`DIGITAIN_999`].pnl += it.pnl
                        pnl_newdata[`DIGITAIN_999`].commission += it.commission
                        pnl_newdata[`DIGITAIN_999`].pnl_commission += it.pnl + it.commission
                        totalpnl += it.pnl
                        totalcommission += it.commission
                        totalnew += it.pnl + it.commission
                     }
                     // else if (it._id.provider === "LOTUS") {
                     //    pnl_newdata[`INDIAN_POKER_99`].pnl_commission += it.pnl + it.commission
                     //    totalnew += it.pnl + it.commission
                     // }
                     // else if (it._id.provider === "SUPERNOVA") {
                     //    pnl_newdata[`INDIAN_POKER_2_99`].pnl_commission += it.pnl + it.commission
                     //    totalnew += it.pnl + it.commission
                     // }
                     // else if (it._id.provider === "DRC" || it._id.provider === "QTECH") {
                     //    pnl_newdata[`CASINO_99`].pnl_commission += it.pnl + it.commission
                     //    totalnew += it.pnl + it.commission
                     // }
                     // else if (it._id.provider === "EVOLUTION") {
                     //    pnl_newdata[`EVOLUTION_99`].pnl_commission += it.pnl + it.commission
                     //    totalnew += it.pnl + it.commission
                     // }
                  })

                  
                  this.setState({ pnl_datanew: pnl_newdata, totalnew: totalnew, totalpnl: totalpnl, totalcommission: totalcommission, isPnlData: res.items.length > 0 ? true : false, showData: true, loader: false })
               }
            );
         } else {
            this.props.notify(res.message, "error")
            this.setState({ pnl_datanew:{}, totalnew:0, isPnlData: false, showData: true, loader: false })
         }
      })
   }

   async onDownload() {
      let linkClick
      const self = this;
  
      this.setState({ csv_json: [] }, () => {
      
         let list = Object.values(this.state.pnl_datanew)

         let items = []
         let i = 0
         for (let x of list) {
           if (!!x["pnl_commission"]) { 
               let dictinory = {}
            
               dictinory["Sport"] = !!x["et"] ? x["sport"] : ""
               dictinory["Market Name"] = x["mt"] === "WINNING_ODDS" ? "LOTTERY" : x["mt"]
               dictinory["P&L"] = x["pnl"]
               dictinory["Commission"] = x["commission"]
               dictinory["Amount"] = x["pnl_commission"]             
                   
               items.push(dictinory)
             }
         }
         this.setState({ csv_json: items }, () => {
            linkClick = setTimeout(function () {
               self.csvLink.current.link.click();
            }, 500)
         })
      })
   }
   
   async onPDFDownload() {
      // let linkClickTimeout
      let printClickTimeout
      this.setState({ pdf_json: [] }, () => {
         this.setState({ pdf_json: Object.keys(this.state.pnl_datanew) }, () => {
            printClickTimeout = setTimeout(function () {
               printJS({
                  printable: 'printJS-div',
                  type: 'html',
                  style: '@page { size: Letter landscape;}',
                  targetStyles: ['*']
               })
            }, 500)
         })
      })
   }


   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   resetForm() {
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ from: weekDate, to: curDate, client_id: "", usersList: [], isPnlData: false, showData: false, pnl_datanew: {}, totalnew:0 })
   }
   onSubmit(e) {
      let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 31) {
         this.props.notify("Date range must be 1 month.", "error")
      }
      else {
         this.setState({ action: "", page_no: 1 }, () => { this.submitForm(); });
      }
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   onDateTimeChange(name, e) {
      this.setState({ [name]: e._d, isPnlData: false, showData: false, pnl_datanew: {}, totalnew:0 })
   }
   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.accounts, value)
         let lst = []
         for (let x of res.usersList) {
            lst.push({ label: x, value: x, title: x, name: x })
         }
         lst.sort(function(a, b) {
             if(a.value.toLowerCase() < b.value.toLowerCase()) return -1;
             if(a.value.toLowerCase() > b.value.toLowerCase()) return 1;
             return 0;
         });
         this.setState({ usersList: lst })
      }
      else {
         this.setState({ [name]: value, usersList: [] })
      }
   }
   render() {

      return (
         <div className="bethubs">
            <Header history = {this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <h5 className="text-blue">Profit &amp; Loss</h5>
                           <div className="row mx-0">
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12 autocomplete-wrapper">
                                    <Autocomplete
                                       value={this.state.client_id}
                                       items={this.state.usersList}
                                       getItemValue={item => item.title}
                                       renderItem={(item, isHighlighted) =>
                                          <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                             {item.title}
                                          </div>
                                       }
                                       inputProps={{ placeholder: 'Search by client' }}
                                       name="client_id"
                                       onChange={(event, client_id) => this.onUserSearch(event, "client_id", client_id)}
                                       onSelect={client_id => this.setState({ client_id })}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mb-2">
                                 <div className="form-group font-12">
                                    <Datetime
                                       value={this.state.from}
                                       onChange={(e) => this.onDateTimeChange("from", e)}
                                       id="from_datetime"
                                       dateFormat={"DD/MM/YYYY"}
                                       timeFormat={"HH:mm"}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mb-2">
                                 <div className="form-group font-12">
                                    <Datetime
                                       value={this.state.to}
                                       onChange={(e) => this.onDateTimeChange("to", e)}
                                       id="to_datetime"
                                       dateFormat={"DD/MM/YYYY"}
                                       timeFormat={"HH:mm"}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mb-2">
                                 <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                    <button className="btn btn-blue" disabled={!!this.state.from && !!this.state.to ? false : true} onClick={(e) => this.onSubmit(e)}>Go</button>
                                    <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                 </div>
                              </div>  
                           </div>
                           {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2"}>Loading......</div> : null}
                           {!!this.state.showData && <div>

                              <div className="row text-center mt-2">
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 my-1">
                                    <div className="d-flex float-left">
                                       <CSVLink
                                          data={this.state.csv_json}
                                          filename={"Profit & Loss.csv"}
                                          asyncOnClick={true}
                                          className="d-none"
                                          ref={this.csvLink}>
                                       </CSVLink>
                                       <button className="btn btn-sm d-inline csv-icon p-0" title="Export Data" onClick={(e) => this.onDownload(e)} disabled={Object.keys(this.state.pnl_datanew).length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img></button>
                                       
                                          <div style={{ display: "none" }}>
                                             <div id="printJS-div">
                                                <table id="exportall" className="table font-12 table-bordered table-sm" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px' }} >
                                                   <thead >
                                                      <tr>
                                                         <th className="pthead">Sport</th>
                                                         <th className="pthead">Market Name</th>
                                                         <th className="pthead">P&L</th>
                                                         <th className="text-right pthead">Commission</th>
                                                         <th className="text-right pthead">Amount</th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                       {!!this.state.loader ?
                                                             <tr bgcolor="#ffffff">
                                                                <td colSpan={17} className="text-center py-5">
                                                                   <h5 className="text-dark font-weight-bold m-0"> Loading...... </h5>
                                                                </td>
                                                             </tr> : this.state.isPnlData ? <>
                                                                {Object.keys(this.state.pnl_datanew).length > 0 && Object.keys(this.state.pnl_datanew).map((sprt, i) => {
                                                                   const sport = this.state.pnl_datanew[sprt]
                                                                   return (<>
                                                                      {!!sport.pnl_commission &&
                                                                         <tr bgcolor="#ffffff" key={i}>
                                                                            <td>{!!sport.et ? sport.sport : ""}</td>
                                                                            <td>{!!sport.mt ? (sport.mt === 'WINNING_ODDS' ? 'LOTTERY' : sport.mt.split("_").join(" ")) : ""}</td>
                                                                            <td className="text-right fbold"><Currency key={"pnl_" + i} className={sport.pnl > 0 ? "text-right text-success fbold" : sport.pnl < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!sport.pnl ? sport.pnl : 0} showColor={false} /></td>
                                                                            <td className="text-right fbold"><Currency key={"commission_" + i} className={sport.commission > 0 ? "text-right text-success fbold" : sport.commission < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!sport.commission ? sport.commission : 0} showColor={false} /></td>
                                                                            <td className="text-right fbold"><Currency key={"pnl_amt_" + i} className={sport.pnl_commission > 0 ? "text-right text-success fbold" : sport.pnl_commission < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!sport.pnl_commission ? sport.pnl_commission : 0} showColor={false} /></td>
                                                                         </tr>
                                                                      }
                                                                      
                                                                   </>);
                                                                })
                                                                }
                                                                {!!this.state.totalnew &&
                                                                   <tr bgcolor="#ffffff">
                                                                      <td colSpan={2} className="fbold">Total</td>
                                                                      <td className="text-right fbold"><Currency key={"pnl_total"} className={this.state.totalpnl > 0 ? "text-right text-success fbold" : this.state.totalpnl < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.totalpnl ? this.state.totalpnl : 0} showColor={false} /></td>
                                                                      <td className="text-right fbold"><Currency key={"commission_total"} className={this.state.totalcommission > 0 ? "text-right text-success fbold" : this.state.totalcommission < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.totalcommission ? this.state.totalcommission : 0} showColor={false} /></td>
                                                                      <td className="text-right fbold"><Currency key={"pnl_commission_total"} className={this.state.totalnew > 0 ? "text-right text-success fbold" : this.state.totalnew < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.totalnew ? this.state.totalnew : 0} showColor={false} /></td>
                                                                   </tr>}
                                                             </>
                                                                :
                                                                <tr>
                                                                   <td colSpan={8} className="text-center py-5"><h5 className="text-danger font-weight-bold m-0">No Profit &amp; Loss Found</h5></td>
                                                                </tr>
                                                          }   
                                                   </tbody>
                                                </table>
                                             </div>
                                          </div>

                                       <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(e)} disabled={Object.keys(this.state.pnl_datanew).length > 0 ? false : true}>
                                          <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon.svg`}></img>
                                       </button>
                                                      
                                      </div>
                                    </div> 
                              </div>

                              <div className="table-responsive">
                                 <table id="example" className="table table-striped table-bordered table-sm addpadding">
                                    <thead>
                                       <tr>
                                          <th className="wid165 pthead">Sport</th>
                                          <th className="pthead">Market Name</th>
                                          <th className="pthead text-right">P&L</th>
                                          <th className="pthead text-right">Commission</th>
                                          <th className="pthead text-right">Amount</th>
                                       </tr>
                                    </thead>
                                    <tbody id="tblAccountStatement">
                                       {!!this.state.loader ?
                                          <tr>
                                             <td colSpan={17} className="text-center py-5">
                                                <h5 className="text-dark font-weight-bold m-0"> Loading...... </h5>
                                             </td>
                                          </tr> : this.state.isPnlData ? <>
                                             {Object.keys(this.state.pnl_datanew).length > 0 && Object.keys(this.state.pnl_datanew).map((sprt, i) => {
                                                const sport = this.state.pnl_datanew[sprt]
                                                return (<>
                                                   {!!sport.pnl_commission &&
                                                      <tr key={i}>
                                                         <td>{!!sport.et ? sport.sport : ""}</td>
                                                         <td>{!!sport.mt ? (sport.mt === 'WINNING_ODDS' ? 'LOTTERY' : sport.mt.split("_").join(" ")) : ""}</td>
                                                         <td className="text-right fbold"><Currency key={"pnl_" + i} className={sport.pnl > 0 ? "text-right text-success fbold" : sport.pnl < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!sport.pnl ? sport.pnl : 0} showColor={false} /></td>
                                                         <td className="text-right fbold"><Currency key={"commission_" + i} className={sport.commission > 0 ? "text-right text-success fbold" : sport.commission < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!sport.commission ? sport.commission : 0} showColor={false} /></td>
                                                         <td className="text-right fbold"><Currency key={"pnl_amt_" + i} className={sport.pnl_commission > 0 ? "text-right text-success fbold" : sport.pnl_commission < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!sport.pnl_commission ? sport.pnl_commission : 0} showColor={false} /></td>
                                                      </tr>
                                                   }
                                                   
                                                </>);
                                             })
                                             }
                                             {!!this.state.totalnew &&
                                                <tr>
                                                   <td colSpan={2} className="fbold">Total</td>
                                                   <td className="text-right fbold"><Currency key={"pnl_total"} className={this.state.totalpnl > 0 ? "text-right text-success fbold" : this.state.totalpnl < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.totalpnl ? this.state.totalpnl : 0} showColor={false} /></td>
                                                   <td className="text-right fbold"><Currency key={"commission_total"} className={this.state.totalcommission > 0 ? "text-right text-success fbold" : this.state.totalcommission < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.totalcommission ? this.state.totalcommission : 0} showColor={false} /></td>
                                                   <td className="text-right fbold"><Currency key={"pnl_commission_total"} className={this.state.totalnew > 0 ? "text-right text-success fbold" : this.state.totalnew < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.totalnew ? this.state.totalnew : 0} showColor={false} /></td>
                                                </tr>}
                                          </>
                                             :
                                             <tr>
                                                <td colSpan={8} className="text-center py-5"><h5 className="text-danger font-weight-bold m-0">No Profit &amp; Loss Found</h5></td>
                                             </tr>
                                       }
                                    </tbody>
                                 </table>
                              </div>
                           </div>}
                           {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProfitLoss);